import { fade as svelteFade, fly as svelteFly } from 'svelte/transition';
import bezierEasing from 'bezier-easing';

export const durations = {
  short: 240,
  normal: 300,
};

export const easings = {
  in: bezierEasing(0.3, 0, 0, 1),
  out: bezierEasing(1, 0, 0.7, 1),
};

export const fade = node =>
  svelteFade(node, {
    duration: durations.short,
    easing: easings.in,
  });

export const fly = (
  node,
  {
    delayMultiplier = 0,
    duration = durations.normal,
    easing = easings.in,
    x = 100,
  } = {},
) => {
  const dir = getComputedStyle(node).direction;

  return svelteFly(node, {
    delay: delayMultiplier * 17,
    duration,
    easing,
    x: dir === 'rtl' ? -1 * x : x,
  });
};
